/* Nensa määräetu: ostolaatikon toiminta.
   Asetukset ja tuotedata tulevat snippets/nensa-pack.liquid ‑tiedostosta (window.nensaPackData).
   Tyylit: snippets/nensa-pack-style.liquid. */
(function(){
  'use strict';
  var root=document.querySelector('[data-nensa-pack]');
  var D=window.nensaPackData;
  if(!root||!D)return;
  var V=D.v||[],items=root.querySelectorAll('.nensa-pack__item'),tiers=root.querySelectorAll('.nensa-pack__tier');
  var totalEl=root.querySelector('[data-total]'),addBtn=root.querySelector('[data-add]'),errEl=root.querySelector('.nensa-pack__err');
  var strip=document.querySelector('[data-nensa-mthumbs]');
  var tier=1,busy=false,touched=[],st=[];
  var mq=window.matchMedia('(max-width: 768px)');
  var c0=root.getAttribute('data-c0')||'';
  for(var k=0;k<items.length;k++){
    var cOn=items[k].querySelector('.nensa-pack__c.is-on'),sOn=items[k].querySelector('.nensa-pack__s.is-on');
    st.push({c:cOn?cOn.getAttribute('data-c'):c0,s:sOn?sOn.getAttribute('data-s'):''});
    touched.push(false);
  }
  function money(c){
    try{if(window.theme&&theme.Currency&&theme.Currency.formatMoney)return theme.Currency.formatMoney(c,theme.settings.moneyFormat);}catch(e){}
    return (c/100).toFixed(2).replace('.',',')+' €';
  }
  function find(c,s){for(var i=0;i<V.length;i++){if(V[i].c===c&&V[i].s===s)return V[i];}return null;}
  function gal(){var el=document.querySelector('.product__main-photos .product-slideshow');return (el&&window.Flickity&&Flickity.data)?Flickity.data(el):null;}
  function placeStrip(){
    if(!strip)return;
    if(mq.matches){
      var ph=document.querySelector('[data-product-images] .product__photos')||document.querySelector('.product__main-photos');
      if(ph&&ph.parentNode&&strip.previousElementSibling!==ph){ph.parentNode.insertBefore(strip,ph.nextSibling);}
      strip.hidden=false;
    }else{strip.hidden=true;}
  }
  function markThumb(i){
    if(!strip)return;
    var b=strip.querySelectorAll('.nensa-mthumbs__b'),on=null;
    for(var j=0;j<b.length;j++){var is=b[j].getAttribute('data-i')===String(i);b[j].classList.toggle('is-on',is);b[j].setAttribute('aria-pressed',is?'true':'false');if(is)on=b[j];}
    if(on&&!strip.hidden){var left=on.offsetLeft-(strip.clientWidth-on.offsetWidth)/2;try{strip.scrollTo({left:Math.max(0,left),behavior:'smooth'});}catch(e){strip.scrollLeft=Math.max(0,left);}}
  }
  placeStrip();
  if(mq.addEventListener)mq.addEventListener('change',placeStrip);else if(mq.addListener)mq.addListener(placeStrip);
  (function waitGal(n){var fl=gal();if(fl){markThumb(fl.selectedIndex);fl.on('change',markThumb);return;}if(n<20)setTimeout(function(){waitGal(n+1);},300);})(0);
  function showMedia(c){
    var m=-1;
    for(var i=0;i<V.length;i++){if(V[i].c===c&&V[i].m>-1){m=V[i].m;break;}}
    if(m<0)return;
    var fl=gal();
    if(fl&&fl.select){fl.select(m);markThumb(m);return;}
    var th=document.querySelectorAll('.product__thumb');
    for(var j=0;j<th.length;j++){if(th[j].getAttribute('data-index')===String(m)){th[j].click();break;}}
  }
  function paintItem(k){
    var it=items[k],s=st[k];
    var cb=it.querySelectorAll('.nensa-pack__c');
    for(var i=0;i<cb.length;i++){var on=cb[i].getAttribute('data-c')===s.c;cb[i].classList.toggle('is-on',on);cb[i].setAttribute('aria-pressed',on?'true':'false');}
    var nm=it.querySelector('[data-cname]');if(nm)nm.textContent=s.c;
    var sb=it.querySelectorAll('.nensa-pack__s');
    for(var j=0;j<sb.length;j++){
      var sz=sb[j].getAttribute('data-s'),v=find(s.c,sz),ok=!!(v&&v.a);
      sb[j].disabled=!ok;
      if(!ok&&s.s===sz)s.s='';
      var on2=s.s===sz;sb[j].classList.toggle('is-on',on2);sb[j].setAttribute('aria-pressed',on2?'true':'false');
    }
  }
  function clearErr(k){items[k].classList.remove('is-err');var e=items[k].querySelector('.nensa-pack__ierr');if(e)e.hidden=true;errEl.hidden=true;}
  function total(){
    var n=tier,full=D.unit*n,save=n>=D.n?(D.save||Math.round(full*D.pct)):0,pay=full-save;
    totalEl.innerHTML='Yhteensä <b>'+money(pay)+'</b> + toimitus alk. '+(pay>=D.free?money(0):D.ship);
    if(!busy)addBtn.textContent=n>1?'Lisää '+n+' '+D.many+' ostoskoriin':'Lisää ostoskoriin';
  }
  function setTier(n){
    tier=n;root.setAttribute('data-tier',String(n));
    for(var i=0;i<tiers.length;i++){var inp=tiers[i].querySelector('input');var on=parseInt(inp.value,10)===n;tiers[i].classList.toggle('is-on',on);inp.checked=on;}
    for(var k=1;k<items.length;k++){
      var show=k<n;items[k].hidden=!show;
      if(show&&!touched[k]){st[k].c=st[0].c;st[k].s='';paintItem(k);}
    }
    errEl.hidden=true;total();
  }
  root.addEventListener('change',function(e){var t=e.target;if(t&&t.name==='nensa-pack-tier')setTier(parseInt(t.value,10));});
  root.addEventListener('click',function(e){
    var it=e.target.closest('.nensa-pack__item');if(!it)return;
    var k=parseInt(it.getAttribute('data-item'),10);
    var cb=e.target.closest('.nensa-pack__c');
    if(cb){st[k].c=cb.getAttribute('data-c');touched[k]=true;paintItem(k);showMedia(st[k].c);return;}
    var sb=e.target.closest('.nensa-pack__s');
    if(sb&&!sb.disabled){st[k].s=sb.getAttribute('data-s');touched[k]=true;paintItem(k);clearErr(k);}
  });
  addBtn.addEventListener('click',function(){
    if(busy)return;
    var miss=-1;
    if(D.hasS){for(var k=0;k<tier;k++){if(!st[k].s){items[k].classList.add('is-err');var ie=items[k].querySelector('.nensa-pack__ierr');if(ie)ie.hidden=false;if(miss<0)miss=k;}}}
    if(miss>-1){errEl.textContent=tier>1?'Valitse jokaisen '+D.gen+' koko.':'Valitse koko.';errEl.hidden=false;items[miss].scrollIntoView({behavior:'smooth',block:'center'});return;}
    var map={},order=[];
    for(var j=0;j<tier;j++){var v=find(st[j].c,st[j].s);if(!v||!v.a){errEl.textContent=D.hasS?'Valitsemasi koko on loppu. Valitse toinen koko.':'Tuote on tilapäisesti loppu.';errEl.hidden=false;return;}if(!map[v.id]){map[v.id]=0;order.push(v.id);}map[v.id]++;}
    var lines=[];for(var x=0;x<order.length;x++)lines.push({id:order[x],quantity:map[order[x]]});
    busy=true;addBtn.disabled=true;var label=addBtn.textContent;addBtn.textContent='Lisätään…';
    var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:lines})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(x){
        if(!x.ok)throw new Error((x.j&&(x.j.description||x.j.message))||'Lisäys ei onnistunut.');
        addBtn.textContent='Lisätty';
        var first=(x.j&&x.j.items&&x.j.items[0])||x.j;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:first,addToCartBtn:addBtn}}));
        setTimeout(function(){busy=false;addBtn.disabled=false;total();},2200);
      })
      .catch(function(err){busy=false;addBtn.disabled=false;addBtn.textContent=label;errEl.textContent=err.message;errEl.hidden=false;});
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    var mb=e.target.closest('.nensa-mthumbs__b');
    if(mb){e.preventDefault();var fl=gal(),i=parseInt(mb.getAttribute('data-i'),10);if(fl)fl.select(i);markThumb(i);return;}
    var go=e.target.closest('[data-nensa-sticky-go]');
    if(go){e.preventDefault();e.stopPropagation();var hdr=document.querySelector('.site-header');var off=(hdr&&getComputedStyle(hdr).position!=='static'?hdr.offsetHeight:0)+12;window.scrollTo({top:root.getBoundingClientRect().top+window.pageYOffset-off,behavior:'smooth'});return;}
    var o=e.target.closest('[data-nensa-psg-open]');
    if(o){e.preventDefault();var d=document.querySelector('[data-nensa-psg]');if(d&&!d.open&&d.showModal){try{d.showModal();}catch(x){}}return;}
    var cl=e.target.closest('[data-nensa-psg-close]');
    if(cl){e.preventDefault();var d2=cl.closest('dialog');if(d2&&d2.open)d2.close();return;}
    if(e.target.tagName==='DIALOG'&&e.target.hasAttribute('data-nensa-psg')&&e.target.open)e.target.close();
  },true);
  total();
})();
